import { render } from "./RakutenSection.vue?vue&type=template&id=a5711bc4&scoped=true"
import script from "./RakutenSection.vue?vue&type=script&lang=js"
export * from "./RakutenSection.vue?vue&type=script&lang=js"

import "./RakutenSection.vue?vue&type=style&index=0&id=a5711bc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5711bc4"]])

export default __exports__